"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = exports.ButtonWrapper = exports.Description = exports.Header = exports.ContentWrapper = void 0;
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
const Button_1 = require("../button/Button");
const mediaQuery_enum_1 = require("../../core/mediaQuery.enum");
exports.ContentWrapper = styled_components_1.default.div `
  padding: 26px 31px;
  min-width: 340px;

  @media (min-width: ${mediaQuery_enum_1.MediaQuery.MEDIUM}px) {
    padding: 104px 124px;
  }
`;
exports.Header = styled_components_1.default.h2 `
  font-size: 18px;
  margin: 24px 0 16px;

  @media (min-width: ${mediaQuery_enum_1.MediaQuery.MEDIUM}px) {
    font-size: 22px;
  }
`;
exports.Description = (0, styled_components_1.default)(material_1.Typography) `
  margin-bottom: 24px;
`;
exports.ButtonWrapper = styled_components_1.default.div `
  margin-top: 44px;
`;
exports.Button = (0, styled_components_1.default)(Button_1.Button) `
  width: 100%;
`;
